const PaginationEllipsis = ({ className = "", dataTestId }) => (
  <span
    aria-hidden="true"
    data-testid={dataTestId}
    className={`cursor-default select-none ${className}`}
  >
    ...
  </span>
);

export default PaginationEllipsis;
